import * as React from 'react';

import classNames from 'classnames';

import {Body} from '../typography/body';
import type {TextSize} from '../typography/body';

import styles from './empty-state-small.module.css';

type Props = {
    icon?: any;
    title: string;
    titleSize?: TextSize;
    subtitle?: React.ReactNode | string;
    subtitleSize?: TextSize;
    cta?: React.ReactNode;
    // If true, the content container will be flexible in height instead of a fixed min-height
    isFlexibleHeight?: boolean;
    iconSpacing?: number;
};

export function EmptyStateSmall(props: Props) {
    const iconSpacing = props.iconSpacing || 32;

    return (
        <div className='flex flex-dir-col align-center justify-center'>
            <div
                style={{gap: iconSpacing}}
                className={classNames({
                    [styles['content-container-flexible']]: props.isFlexibleHeight,
                    [styles['content-container-fixed']]: !props.isFlexibleHeight,
                })}
            >
                {props.icon}
                <div className={styles['empty-text']}>
                    <Body isBold={true} color='dark' size={props.titleSize || 'large'}>
                        {props.title}
                    </Body>
                    {props.subtitle && (
                        <Body size={props.subtitleSize || 'normal'}>{props.subtitle}</Body>
                    )}
                </div>
            </div>
            {props.cta}
        </div>
    );
}
